/**
 * @ngdoc overview
 * @name evtviewer.translation
 * @module evtviewer.translation
 * @description 
 * # evtviewer.translation
 * Module referring to User Interface translation
 *
 * ## Services
 * - {@link evtviewer.translation.evtTranslation evtTranslation} where are defined and exposed 
 * methods to handle UI translation.
**/
angular.module('evtviewer.translation', []);